<template>
  <div class="interest_form">
    <header class="header">
      <h3>
        <span>利益演示</span>
        <span
          v-if="isShowSettingButton"
          class="setting-btn"
          data-stat-id="lyxsxsx"
          :data-stat-ep="JSON.stringify({
            type: settingStore.displayType
          })"
          @click="$emit('update', { isShowFieldPopup: true })"
        >
          <i class="iconfont icon-screen" />
          <em>设置</em>
        </span>
      </h3>
      <div class="show_type">
        <div class="container">
          <span
            v-for="o in DISPLAY_TYPE_OPTIONS"
            :key="o.key"
            :class="{
              active: o.key === settingStore.displayType
            }"
            data-stat-id="lyqh"
            :data-stat-ep="JSON.stringify({
              key: o.key
            })"
            @click="$emit('update', {
              displayType: o.key
            })"
          >
            <i :class="['iconfont', o.icon]" />
            <em>{{ o.name }}</em>
          </span>
        </div>
      </div>
    </header>
    <header v-if="isScreenCaptureShow && isShowHeaderFixed" class="header_fixed">
      <span
        v-for="o in DISPLAY_TYPE_OPTIONS"
        :key="o.key"
        :class="{
          active: o.key === settingStore.displayType
        }"
        @click="$emit('update', {
          displayType: o.key
        })"
      >{{ o.name }}</span>
    </header>
    <section class="main">
      <ul v-if="interestDemoOptions" class="conditions">
        <li v-for="item in interestDemoOptions" :key="item.key" class="condition">
          <div class="left">
            {{ item.name }}
          </div>
          <div class="right">
            <div>
              <template v-for="o in item.options">
                <span
                  v-if="!o.hiddenFlag"
                  :key="o.value + (o.index || 0)"
                  class="option-pill"
                  :class="{
                    active: isActiveOption(item, o)
                  }"
                  :data-stat-id="item.stat"
                  :data-stat-ep="JSON.stringify({ key: o.value })"
                  @click="onClickItem(item, o)"
                >{{ o.description }}</span>
              </template>
            </div>
            <!-- data-stat-ep {key: -1} 是保持 WYJHS-959 修改前的逻辑，即“设置X”入口传入 -1 -->
            <div
              v-if="item.actionBtnTx"
              class="link-btn"
              :data-stat-id="item.stat"
              :data-stat-ep="JSON.stringify({ key: -1 })"
              @click="openItemSetting(item)"
            >
              {{ item.actionBtnTx }} <i class="iconfont icon-arrows_right" />
            </div>
          </div>
        </li>
      </ul>
    </section>
    <InterestFormRate
      v-model="isShowRatePopup"
      :form-data="formData"
      :has-custom-rate="hasCustomRate"
      :previous-rate="cachePreviousRate"
      @update="data => $emit('update', data)"
    />
  </div>
</template>
<script>
import { DISPLAY_TYPE_OPTIONS } from '../constant'
import InterestFormRate from './interest-form-rate.vue'

export default {
  components: {
    InterestFormRate
  },
  props: {
    isScreenCaptureShow: Boolean,
    settingStore: {
      type: Object,
      required: true,
      default: () => ({})
    },
    formData: {
      type: Object
    },
    interestDemoOptions: {
      type: Array,
      default: () => []
    },
    params: {
      type: Object,
      default: () => ({})
    },
  },
  data () {
    return {
      cachePreviousRate: null,
      isApp: window.appBridge && window.appBridge.isApp(),
      isShowHeaderFixed: false,

      DISPLAY_TYPE_OPTIONS
    }
  },
  computed: {
    isShowRatePopup () {
      return this.formData.formValues.isShowRatePopup
    },
    hasCustomRate () {
      const rateItem = this.interestDemoOptions.find(o => o.key === 'rate')
      return rateItem && rateItem.hasCustomRate
    },
    isShowSettingButton () {
      return this.isApp && !this.params.isForPresentation
    },
  },
  mounted () {
    const self = this
    window.addEventListener('scroll', () => {
      self.showHeaderFixed()
    })
    document.addEventListener('touchmove', () => {
      self.showHeaderFixed()
    })
    self.showHeaderFixed()
  },
  methods: {
    showHeaderFixed() {
      const fixedDom = document.querySelector('#interestDemo')
      const rect = fixedDom && fixedDom.getBoundingClientRect()
      if (!rect) {
        return
      }
      this.isShowHeaderFixed = (rect.y + 30) <= 0 && (rect.bottom - 30) >= 0
    },
    isActiveOption (item, option) {
      const { settingStore, formData } = this
      if (['activeProductId'].includes(item.key) && option.value === settingStore[item.key]) {
        return true
      }
      if (['rate'].includes(item.key)) {
        const { rateIndex } = formData.formValues
        return option.index === rateIndex || (rateIndex === -1 && Math.abs(formData.customRate - option.value) < 1e-5)
      }
      if (['addAndTakeData', 'drawData'].includes(item.key)) {
        return option.value === (item.key === 'drawData' ? formData.formValues.drawFlag : formData.formValues.addAndTakeFlag)
      }
      return option.value === formData.formValues[item.key]
    },
    onClickItem(item, option) {
      const self = this
      if (item.key === 'rate') {
        self.$emit('update', {
          rateIndex: option.index,
          rate: option.value
        })
      } else if (['addAndTakeData', 'drawData'].includes(item.key)) {
        self.$emit('update', {
          [item.key === 'drawData' ? 'drawFlag' : 'addAndTakeFlag']: option.value
        })
      } else {
        self.$emit('update', {
          [item.key]: option.value
        })
      }
    },
    openItemSetting (item) {
      const self = this
      if (item.key === 'rate') {
        self.cachePreviousRate = self.formData.formValues.rate ? Number(self.formData.formValues.rate) : null
        self.$emit('update', {
          isShowRatePopup: true
        })
      } else if (['addAndTakeData', 'drawData'].includes(item.key)) {
        self.$emit('open-add-and-take', item)
      }
    }
  }
}
</script>
<style lang="postcss">
@import './interest-form.css';
</style>
